<style scoped>
    .action-link {
        cursor: pointer;
    }
</style>

<template>
    <div>
        <h1 class="card-title">{{$t('API Keys')}}</h1>
        <a class="btn btn-sm btn-action btn-primary" tabindex="-1" @click="store" href="#">
            <i class="fas fa-key btn-icon-prepend"></i> {{$t('Generate new API key')}}
        </a>

        <div class="position-relative" v-if="accessToken">
            <div class="popover position-relative bs-popover-bottom bs-popover-bottom-demo popover-success" style="max-width: 600px">
                <div class="arrow"></div>
                <h3 class="popover-header">{{ $t('Your API key') }}</h3>
                <div class="popover-body">
                    <div>{{$t('This is the only time it will be shown so don\'t lose it!')}}</div>
                    <textarea class="form-control mb-2" rows="5" onclick="this.select()">{{ accessToken }}</textarea>
                    <Clipboard :hidden-text="accessToken"/>
                </div>
            </div>
        </div>

        <div class="alert alert-warning mt-4" v-if="tokens.length === 0 && listLoader === false">
            {{$t('You have not created any personal access tokens.')}}
        </div>

        <div class="table-responsive" v-if="tokens.length > 0">
            <table class="table table-hover">
                <thead>
                <tr>
                    <th>{{$t('Name')}}</th>
                    <th>{{$t('Created At')}}</th>
                    <th>{{$t('Expired At')}}</th>
                    <th></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="token in tokens">
                    <td>
                        {{ token.name }}
                    </td>
                    <td>
                        {{ token.created_at | formatDate}}
                    </td>
                    <td>
                        {{ token.expires_at | formatDate}}
                    </td>
                    <td style="vertical-align: middle;">
                        <a class="action-link text-danger" @click="revoke(token)">
                            {{$t('Delete')}}
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Clipboard from '../Clipboard'
    export default {
        /*
         * The component's data.
         */
        components: {Clipboard},
        data() {
            return {
                accessToken: null,
                listLoader: true,
                createLoader: false,

                tokens: [],
                scopes: [],

                form: {
                    name: '',
                    scopes: [],
                    errors: []
                }
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component.
             */
            prepareComponent() {
                this.getTokens();
                this.getScopes();

                $('#modal-create-token').on('shown.bs.modal', () => {
                    $('#create-token-name').focus();
                });
            },

            /**
             * Get all of the personal access tokens for the user.
             */
            getTokens() {
                this.listLoader = true
                axios.get('/oauth/personal-access-tokens')
                        .then(response => {
                            this.tokens = response.data;
                        }).finally(res => {
                            this.listLoader = false
                            this.accessToken = null
                        });
            },

            /**
             * Get all of the available scopes.
             */
            getScopes() {
                axios.get('/oauth/scopes')
                        .then(response => {
                            this.scopes = response.data;
                        });
            },

            /**
             * Show the form for creating new tokens.
             */
            showCreateTokenForm() {
                $('#modal-create-token').modal('show');
            },

            /**
             * Create a new personal access token.
             */
            store() {
                if (this.tokens.length >= 5) {
                    $.toast({
                        heading: 'Error',
                        text: this.$t('You can\'t create more than 5 keys'),
                        showHideTransition: 'slide',
                        icon: 'error',
                        loaderBg: '#ddd',
                        position: 'top-center'
                    })
                    return
                }
                if (this.createLoader === true) {
                    return
                }
                this.createLoader = true
                axios.post('/oauth/personal-access-tokens', {name: 'API Token'})
                        .then(response => {
                            this.createLoader = false
                            this.tokens.push(response.data.token);
                            this.showAccessToken(response.data.accessToken);
                        })
                        .catch(error => {
                            console.log(error)
                            this.createLoader = false
                            $.toast({
                                heading: 'Error',
                                text: 'Please try again',
                                showHideTransition: 'slide',
                                icon: 'error',
                                loaderBg: '#ddd',
                                position: 'top-center'
                            })
                        });
            },

            /**
             * Show the given access token to the user.
             */
            showAccessToken(accessToken) {
                this.accessToken = accessToken;
            },

            /**
             * Revoke the given token.
             */
            revoke(token) {
                axios.delete('/oauth/personal-access-tokens/' + token.id)
                        .then(response => {
                            this.getTokens();
                        });
            }
        }
    }
</script>
